<!-- @format -->

<sis-description-list>
  <dl>
    @if (formalRecommendation) {
      <ng-container>
        <ng-template #listItem>
          <dt class="sis-label">{{ "RECOMMENDATION." + approvalRequestType + ".FORMAL_STATE" | translate }}</dt>
          <dd>
            @switch (formalRecommendation.state) {
              @case (recommendationState.NOT_HANDLED) {
                <ng-container>{{ "RECOMMENDATION." + approvalRequestType + ".NOT_HANDLED" | translate }}</ng-container>
              }
              @case (recommendationState.RECOMMENDED) {
                <ng-container>{{ "RECOMMENDATION." + approvalRequestType + ".RECOMMENDED" | translate }}</ng-container>
              }
              @case (recommendationState.NOT_RECOMMENDED) {
                <ng-container>{{ "RECOMMENDATION." + approvalRequestType + ".NOT_RECOMMENDED" | translate }}</ng-container>
              }
            }
          </dd>
        </ng-template>
        @if (formalRecommendation.responsiblePerson || formalRecommendation.additionalInformation) {
          <ng-template #listItem>
            <dt class="sis-label">{{ "RECOMMENDATION." + approvalRequestType + ".FORMAL_PERSON" | translate }}</dt>
            <dd
              >{{ formalRecommendation.responsiblePerson | publicPerson | async | personFullName }},
              {{ formalRecommendation.responsiblePersonTitle | localizedString }}
              @if (formalRecommendation.additionalInformation) {
                <ng-container>{{ formalRecommendation.additionalInformation }}</ng-container>
              }
            </dd>
          </ng-template>
        }
        @if (formalRecommendation.comment) {
          <ng-template #listItem>
            <dt class="sis-label">{{ "RECOMMENDATION." + approvalRequestType + ".FORMAL_COMMENT" | translate }}</dt>
            <dd class="text-area-static">{{ formalRecommendation.comment }}</dd>
          </ng-template>
        }
      </ng-container>
    }
    @if (contentRecommendation) {
      <ng-container>
        <ng-template #listItem>
          <dt class="sis-label">{{ "RECOMMENDATION." + approvalRequestType + ".CONTENT_STATE" | translate }}</dt>
          <dd>
            @switch (contentRecommendation.state) {
              @case (recommendationState.NOT_HANDLED) {
                <ng-container>{{ "RECOMMENDATION." + approvalRequestType + ".NOT_HANDLED" | translate }}</ng-container>
              }
              @case (recommendationState.RECOMMENDED) {
                <ng-container>{{ "RECOMMENDATION." + approvalRequestType + ".RECOMMENDED" | translate }}</ng-container>
              }
              @case (recommendationState.NOT_RECOMMENDED) {
                <ng-container>{{ "RECOMMENDATION." + approvalRequestType + ".NOT_RECOMMENDED" | translate }}</ng-container>
              }
            }
          </dd>
        </ng-template>
        <ng-container>
          @if (contentRecommendation.responsiblePerson || contentRecommendation.additionalInformation) {
            <ng-template #listItem>
              <dt class="sis-label">{{ "RECOMMENDATION." + approvalRequestType + ".CONTENT_PERSON" | translate }}</dt>
              <dd>
                {{ contentRecommendation.responsiblePerson | publicPerson | async | personFullName }},
                {{ contentRecommendation.responsiblePersonTitle | localizedString }}
                @if (contentRecommendation.additionalInformation) {
                  <ng-container>{{ contentRecommendation.additionalInformation }}</ng-container>
                }
              </dd>
            </ng-template>
          }
        </ng-container>
        <ng-container>
          @if (contentRecommendation.comment) {
            <ng-template #listItem>
              <dt class="sis-label">{{ "RECOMMENDATION." + approvalRequestType + ".CONTENT_COMMENT" | translate }}</dt>
              <dd class="text-area-static">{{ contentRecommendation.comment }}</dd>
            </ng-template>
          }
        </ng-container>
      </ng-container>
    }
  </dl>
</sis-description-list>
